var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-wrapper"},[_vm._l((_vm.imageSources),function(image,index){return _c('img',{attrs:{"src":image,"alt":`csepel-photo-${index}`},on:{"click":function($event){return _vm.openImage(index)}}})}),(_vm.selectedImage)?_c('imageViewerPopup',{attrs:{"selectedImage":_vm.selectedImage},on:{"close":_vm.closeDialog}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }